import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type UserPreferences = {
  default_ai_model?: string;
  default_language?: string;
  default_tone?: string;
  default_audience?: string;
  default_article_type?: 'general' | 'how_to' | 'list';
  default_section_length?: 'short' | 'medium' | 'long';
};

export function usePreferences() {
  return useQuery({
    queryKey: ['preferences'],
    queryFn: () => api.get<{ preferences: UserPreferences }>('/api/app/preferences'),
  });
}

export function useSavePreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UserPreferences) =>
      api.patch<{ preferences: UserPreferences }>('/api/app/preferences', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['preferences'] }),
  });
}
